import React from 'react';
import { Link } from 'react-router-dom';
import { HeartHandshakeIcon, BrainIcon, LightbulbIcon, BuildingIcon, CheckCircleIcon } from 'lucide-react';
const FutureHubPage = () => {
  return <div className="bg-white min-h-screen w-full" data-id="element-393">
      <div className="relative h-64 md:h-80 lg:h-96 overflow-hidden" data-id="element-394">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2St8j7dtP7wGSk7uTwFS99/ayira_s_neuro_soul_cafe_cover.jpg" alt="Inclusive Futures Hub concept" className="w-full h-full object-cover" data-id="element-395" />
        <div className="absolute inset-0 bg-gradient-to-r from-amber-900/60 to-green-900/60 flex items-center justify-center" data-id="element-396">
          <div className="text-center" data-id="element-397">
            <div className="inline-block mb-4 px-6 py-2 bg-amber-500 text-white rounded-full text-sm font-medium" data-id="element-398">
              Coming Soon
            </div>
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-white" data-id="element-399">
              Inclusive Futures Hub
            </h1>
          </div>
        </div>
      </div>
      <div className="container mx-auto max-w-5xl py-16 px-6" data-id="element-400">
        <div className="text-center mb-12" data-id="element-401">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold mb-4" data-id="element-402">
            A Visionary Space for Neurodivergent Inclusion
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-403">
            The Inclusive Futures Hub will be a dedicated center advancing
            therapy, training, and employment for neurodivergent individuals.
            Designed to be inclusive, accessible, and sustainable.
          </p>
        </div>
        <div className="mb-16" data-id="element-404">
          <div className="relative overflow-hidden rounded-lg shadow-lg" data-id="element-405">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/o6UMt4pmcsm7hWRsQkg56b/A_visionary_space_for_neurodivergent_inclusion_and_empowerment._Our_upcoming_hub_will_be_a_dedicated_center_advancing_therapy%2C_training%2C_and_employment_for_neurodivergent_individuals_in_africa.jpg" alt="Inclusive Futures Hub concept" className="w-full h-auto" data-id="element-406" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent flex items-end" data-id="element-407">
              <div className="p-6 text-white" data-id="element-408">
                <p className="text-lg md:text-xl font-light" data-id="element-409">
                  A visionary space for neurodivergent inclusion and
                  empowerment. Our upcoming hub will be a dedicated center
                  advancing therapy, training, and employment for neurodivergent
                  individuals.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-16 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-410">
          <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-lg p-8 shadow-md" data-id="element-411">
            <div className="flex items-center mb-6" data-id="element-412">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4" data-id="element-413">
                <BuildingIcon size={24} className="text-amber-600" data-id="element-414" />
              </div>
              <h3 className="text-2xl font-serif font-semibold" data-id="element-415">The Vision</h3>
            </div>
            <div className="prose prose-lg" data-id="element-416">
              <p data-id="element-417">
                The Inclusive Futures Hub will be a purpose-built space where
                neurodivergent individuals, their families, and support
                professionals can access comprehensive services under one roof.
              </p>
              <p data-id="element-418">
                More than a building, it will be a launchpad for systemic change
                — a place where ability is redefined, dignity is central, and
                every person is equipped to thrive.
              </p>
            </div>
          </div>
          <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-8 shadow-md" data-id="element-419">
            <div className="flex items-center mb-6" data-id="element-420">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4" data-id="element-421">
                <LightbulbIcon size={24} className="text-green-600" data-id="element-422" />
              </div>
              <h3 className="text-2xl font-serif font-semibold" data-id="element-423">
                Our Approach
              </h3>
            </div>
            <div className="prose prose-lg" data-id="element-424">
              <p data-id="element-425">
                We're designing the hub with input from neurodivergent
                individuals, caregivers, and professionals to ensure it truly
                meets the needs of those it will serve.
              </p>
              <p data-id="element-426">
                Every aspect of the hub — from sensory considerations to program
                design — will reflect our commitment to dignity, equity,
                community, and neuro-inclusion.
              </p>
            </div>
          </div>
        </div>
        <div className="mb-16" data-id="element-427">
          <h3 className="text-2xl font-serif font-semibold mb-8 text-center" data-id="element-428">
            What the Hub Will Offer
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-429">
            <div className="bg-white border border-amber-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-430">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-431">
                <BrainIcon size={32} className="text-amber-600" data-id="element-432" />
              </div>
              <h4 className="text-xl font-serif font-semibold mb-4 text-center" data-id="element-433">
                Integrated Therapy & Diagnostics
              </h4>
              <ul className="space-y-3" data-id="element-434">
                <FeatureItem data-id="element-435">Evidence-based therapy services</FeatureItem>
                <FeatureItem data-id="element-436">Accessible diagnostic assessments</FeatureItem>
                <FeatureItem data-id="element-437">Family support services</FeatureItem>
                <FeatureItem data-id="element-438">Telehealth options for remote areas</FeatureItem>
              </ul>
            </div>
            <div className="bg-white border border-green-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-439">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-440">
                <HeartHandshakeIcon size={32} className="text-green-600" data-id="element-441" />
              </div>
              <h4 className="text-xl font-serif font-semibold mb-4 text-center" data-id="element-442">
                Vocational Training & Employment
              </h4>
              <ul className="space-y-3" data-id="element-443">
                <FeatureItem data-id="element-444">Skills assessment and development</FeatureItem>
                <FeatureItem data-id="element-445">Job coaching and mentorship</FeatureItem>
                <FeatureItem data-id="element-446">Employer partnerships</FeatureItem>
                <FeatureItem data-id="element-447">Supported work environments</FeatureItem>
              </ul>
            </div>
            <div className="bg-white border border-purple-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-448">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-449">
                <LightbulbIcon size={32} className="text-purple-600" data-id="element-450" />
              </div>
              <h4 className="text-xl font-serif font-semibold mb-4 text-center" data-id="element-451">
                Community & Education
              </h4>
              <ul className="space-y-3" data-id="element-452">
                <FeatureItem data-id="element-453">Caregiver training programs</FeatureItem>
                <FeatureItem data-id="element-454">
                  Professional development for educators
                </FeatureItem>
                <FeatureItem data-id="element-455">Community awareness events</FeatureItem>
                <FeatureItem data-id="element-456">Neurodiversity advocacy resources</FeatureItem>
              </ul>
            </div>
          </div>
        </div>
        <div className="mb-16" data-id="element-457">
          <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-8 shadow-md" data-id="element-458">
            <h3 className="text-2xl font-serif font-semibold mb-6 text-center" data-id="element-459">
              Designed for Inclusion
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-460">
              <div data-id="element-461">
                <h4 className="text-lg font-medium mb-4" data-id="element-462">
                  Sensory-Friendly Features:
                </h4>
                <ul className="space-y-3" data-id="element-463">
                  <FeatureItem data-id="element-464">Thoughtful lighting design</FeatureItem>
                  <FeatureItem data-id="element-465">Acoustic considerations</FeatureItem>
                  <FeatureItem data-id="element-466">Sensory regulation spaces</FeatureItem>
                  <FeatureItem data-id="element-467">Calming color palette</FeatureItem>
                </ul>
              </div>
              <div data-id="element-468">
                <h4 className="text-lg font-medium mb-4" data-id="element-469">
                  Accessibility Features:
                </h4>
                <ul className="space-y-3" data-id="element-470">
                  <FeatureItem data-id="element-471">Universal design principles</FeatureItem>
                  <FeatureItem data-id="element-472">Clear wayfinding and signage</FeatureItem>
                  <FeatureItem data-id="element-473">Adaptive technology integration</FeatureItem>
                  <FeatureItem data-id="element-474">Inclusive outdoor spaces</FeatureItem>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-475">
          <h3 className="text-2xl font-serif font-semibold mb-6" data-id="element-476">
            Join Us in Building the Future
          </h3>
          <p className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto" data-id="element-477">
            The Inclusive Futures Hub represents our vision for what's possible
            when we prioritize neurodiversity inclusion. We invite you to be
            part of this groundbreaking initiative.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-478">
            <Link to="/visit" className="inline-block bg-amber-600 hover:bg-amber-700 text-white px-6 py-3 rounded-md font-medium transition duration-300" data-id="element-479">
              Visit Our Current Café
            </Link>
            <a href="tel:+254746210909" className="inline-block bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-md font-medium transition duration-300" data-id="element-480">
              Contact Us About the Hub
            </a>
          </div>
        </div>
      </div>
    </div>;
};
const FeatureItem = ({
  children
}) => <li className="flex items-start" data-id="element-481">
    <CheckCircleIcon size={20} className="text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-482" />
    <span data-id="element-483">{children}</span>
  </li>;
export default FutureHubPage;